// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3528eb4e]{display:none}.sticker-image[data-v-3528eb4e]{height:71.92px;width:71.92px}@media(min-width:768px){.sticker-image[data-v-3528eb4e]{height:107px;width:107px}}@media(min-width:1024px){.sticker-image[data-v-3528eb4e]{height:115.39px;margin-right:30px;width:115.39px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
